module.exports = __webpack_public_path__ + "img/icon.19f45e72.png";